import * as React from "react";
import { cn } from "../../lib/utils";

type HeadingTag = "h1" | "h2" | "h3";

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
	as?: HeadingTag;
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
	({ as: Tag = "h1", className, children, ...props }, ref) => (
		<Tag
			ref={ref}
			className={cn(
				"mb-2 font-bold tracking-tight text-orange-500",
				Tag === "h1" && "text-3xl",
				Tag === "h2" && "text-2xl text-orange-400",
				Tag === "h3" && "text-xl text-orange-400",
				className,
			)}
			{...props}
		>
			{children}
		</Tag>
	),
);

Heading.displayName = "Heading";

export { Heading };
